import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 20,
		cy: 20,
		r: 8
	})
});
export default SvgDot;
